import React from 'react';
import { useToastStore } from '@stores/toastStore';
import CustomToast from './CustomToast';

const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { toasts, removeToast } = useToastStore();

  // Zobrazíme jen poslední toast
  const currentToast = toasts.length > 0 ? toasts[toasts.length - 1] : null;

  return (
    <>
      {children}
      {currentToast && (
        <CustomToast
          key={currentToast.id} // Klíč pro správné přerenderování
          toast={currentToast}
          onClose={() => removeToast(currentToast.id)}
        />
      )}
    </>
  );
};

export default ToastProvider;
